module.exports = __webpack_public_path__ + "img/root000.dbc5f99f.png";